import React from 'react'
import { PropTypes } from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import { COLOR_TURQUOISE, COLOR_WHITE } from '../../lib/colors'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const UILink = ({
  target = '_blank',
  redirection,
  linkTitle,
  linkStyle = 'pdf',
  alt,
  socialIcon,
}) => {
  return (
    <a
      href={redirection}
      className={css([styles.basic, styles[linkStyle]])}
      target={target}
      alt={alt}
      rel="noopener noreferrer"
    >
      {linkTitle && linkTitle}
      {socialIcon && socialIcon}
    </a>
  )
}

const styles = StyleSheet.create({
  basic: {
    border: 'none',
    textDecoration: 'none',
    ':hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  pdf: {
    fontSize: 14,
    fontWeight: 400,
    color: COLOR_WHITE,
    [MEDIA_MIN_SM]: {
      fontSize: 12,
    },
  },
  custom: {
    color: 'black',
    textDecoration: 'underline',
  },
  socialMedia: {
    padding: 5,
  },
  simple: {
    fontSize: 20,
    fontWeight: 400,
    color: COLOR_TURQUOISE,
    [MEDIA_MIN_SM]: {
      fontSize: 15,
    },
  },
})

UILink.propTypes = {
  linkTitle: PropTypes.string,
  redirection: PropTypes.string.isRequired,
  target: PropTypes.string,
  linkStyle: PropTypes.oneOf(['pdf', 'socialMedia']),
  alt: PropTypes.string,
  socialIcon: PropTypes.object,
}

export default UILink
